<template>
  <div class="container">
    <h1>403: Access Denied</h1>
    <p>No permissions to view directly this page.</p>
  </div>
</template>

<script>
export default {
  name: "403Error",
};
</script>

<style scoped>
body {
  background-color: #f2f2f2;
  text-align: center;
  padding: 50px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h1 {
  font-size: 50px;
}

.container {
  display: inline-block;
  max-width: 480px;
  margin: 0 auto;
  color: #666;
}
</style>
